import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from 'lucide-react';
export const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  // Don't show breadcrumbs on home page
  if (pathnames.length === 0) {
    return null;
  }
  // Map of path segments to display names
  const pathMap: Record<string, string> = {
    diensten: 'Diensten',
    'over-ons': 'Over Ons',
    contact: 'Contact',
    'afspraak-maken': 'Afspraak Maken',
    'veelgestelde-vragen-faq': 'FAQ',
    privacybeleid: 'Privacybeleid',
    'algemene-voorwaarden': 'Algemene Voorwaarden',
    'lichten-smoken': 'Lichten Smoken',
    ontchromen: 'Ontchromen',
    'ramen-tinting': 'Ramen Tinting',
    alloygator: 'AlloyGator',
    autowrappen: 'Auto Wrappen',
    'maatwerk-advies': 'Maatwerk Advies'
  };
  return <div className="bg-[#0a0a0a] border-b border-white/5 pt-32 pb-4" data-id="element-94">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-95">
        <nav className="flex" aria-label="Breadcrumb" data-id="element-96">
          <ol className="flex items-center space-x-2 text-sm" data-id="element-97">
            <li data-id="element-98">
              <Link to="/" className="text-white/60 hover:text-white transition-colors duration-200 flex items-center" data-id="element-99">
                <HomeIcon size={14} className="mr-1" data-id="element-100" />
                Home
              </Link>
            </li>
            {pathnames.map((name, index) => {
            // Build the path up to this point
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            return <li key={name} className="flex items-center" data-id="element-101">
                  <ChevronRightIcon size={14} className="text-white/40" data-id="element-102" />
                  {isLast ? <span className="ml-2 text-white font-medium" data-id="element-103">
                      {pathMap[name] || name.charAt(0).toUpperCase() + name.slice(1)}
                    </span> : <Link to={routeTo} className="ml-2 text-white/60 hover:text-white transition-colors duration-200" data-id="element-104">
                      {pathMap[name] || name.charAt(0).toUpperCase() + name.slice(1)}
                    </Link>}
                </li>;
          })}
          </ol>
        </nav>
      </div>
    </div>;
};